import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";


import ace from "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/theme-dracula";
import "ace-builds/src-noconflict/theme-terminal";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/mode-javascript";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-latex";
// import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/ext-searchbox";
import "ace-builds/src-noconflict/ext-spellcheck";
import { enableSpellCheck } from "./SpellCheck";
import styles from "./Ace.module.css";

import { HStack, IconButton, ButtonGroup, Tooltip, Modal, ModalBody, useDisclosure, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, Box, Button, Spinner, FormControl, FormLabel, Switch, Text } from "@chakra-ui/react";
import PopOver from "./Popover";
import {
  getAllBibitems,
  getAllEquations,
  getAllTables,
  showDeletedOnHover,
  querySelector,
  processSelection
} from "../Utils/utils";
import { getCitationMarkers, getInlineEqnMarkers, getEqnMarkers } from "../Utils/getMarkers";
import CitationPopup from "./CitationPopup";
import MathPopup from "./MathPopup";
// import { saveTexApi, downloadTexApi } from "../api";
import ImagePopup from "./ImagePopup";
import { InsertMath } from "./InsertMath";
import { diff_match_patch } from "diff-match-patch";
import { TiTick } from "react-icons/ti";
import {
  SaveIcon, SearchIcon, ReplaceIcon, BoldIcon, ItalicIcon, Auto, Resize1, Resize2, MenuBar, MenuClose, HideChange,
  ShowChange
} from "./icons";
import { connect } from "react-redux";
import epl from "../eplstyles";
import edp from "../clientstyles/edpstyles"
import { useNavigate, useParams } from "react-router-dom";
import Loading from "./Loading";

import { textToBold, textToItalics } from "../Utils/shortcutBindings"

import { get_all_project_file_Api, update_project_file_Api } from "../dashboardapi";
import { aceShortcuts } from "./AceShortcuts";

import aces from "ace-builds";
import { set } from "lodash";
import ReusableModal from "./EditTools/Modal";
import { useTheme } from "../Themes/ThemeContext";
// import { useMemo } from "react";
// import { debounce } from "lodash";
// import Tablepopup from "./Tablepopup";
ace.config.set("basePath", "/ace");

const AceFunctional = forwardRef((props, ref) => {
  const {
    isOpen: alertOpen,
    onToggle: onalertToogle,
    onClose: onalertClose,
  } = useDisclosure();

  const { theme: customtheme } = useTheme()

  const dmp = new diff_match_patch();
  const toast = props.toast;
  const ace = useRef(null);

  const editorRef = useRef(null);
  // const popup = useRef();
  const [texFile, setTexFile] = useState("");
  const { isOpen: suggestOpen, onOpen: suggestToggle, onClose: suggestClose } = useDisclosure();

  // const [textFiletoCompare, settexFiletoCompare] = useState('')
  const [filename, setFilename] = useState("");
  const [markers, setMarkers] = useState([]);
  const [bibitems, setBibitems] = useState({});
  const [equations, setEquations] = useState({});
  const [tables, setTables] = useState({});
  const [actualValue, setActualValue] = useState("");
  const [toolActualValue, setToolActualValue] = useState("");
  const [lastSearch, setLastSearch] = useState("");
  const [check, setCheck] = useState(false);
  const [toggleChange, setToggleChange] = useState(true);
  const [changes, setChanges] = useState([]);
  const [fileId, setFileID] = useState("");
  const [diffList, setDiffList] = useState([]);
  const [toolDiffList, setToolDiffList] = useState({});
  const [popUp, setPopUp] = useState({
    popup: { x: -100, y: -100, show: false, header: "", body: "", type: "" },
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { projectid, file } = useParams();
  const [performancetime, setPerformanceTime] = useState("");
  const [alerttoshow, setAlertToShow] = useState(0)
  const [client, setClient] = useState([])
  // let alert = 0;
  const corrections = props?.corrections || {};

  const isEditable = !Object.values(corrections).every(
    (val) => Array.isArray(val) ? val.length === 0 : !val
  );

  useEffect(() => {
    const projectfiles = async () => {
      const files = await get_all_project_file_Api(projectid);
      try {
        if (files.data) {
          console.log(files.data);
          files.data.forEach((item, id) => {
            if (item.name === file) {
              setToolActualValue(item.proof_content ? item.proof_content : item.content)
              setActualValue(item.proof_content ? item.proof_content : item.content)
              setTexFile(item.content)
              //ace?.current?.editor?.setValue(item.content, -1);
              setFilename(item.name)
              setFileID(item.file_uuid)
              props.setFileName(item.project_name);
            }
          })
        } else {
          toast({
            title: "Error",
            description: "No such project found",
            status: "error",
            duration: 2000,
            isClosable: "true"
          })
          navigate("/dashboard/myprojects");
        }
      } catch (error) {
        setTexFile("No Files Found")
        setLoading(false)
      } finally {
        setLoading(false)
      }
      setTimeout(() => {
        // enableMarkers();
        ace.current?.editor?.session.getUndoManager().reset();
      }, 2000);
    }
    projectfiles();

    ace.current.editor.setOption("enableMultiselect", false);
  }, [ace, file])


  useEffect(() => {
    if (performancetime > 50 && alerttoshow < 1) {
      onalertToogle()
      setAlertToShow(1)
    }
  }, [performancetime])


  function smartTrim(str, direction = "start") {
    if (!str) return "";

    const limit = 30;

    if (direction === "start") {
      let cutIndex = Math.min(limit, str.length);
      for (let i = 0; i < cutIndex; i++) {
        const pair = str.slice(i, i + 2);
        const char = str[i];

        if (["/", "\\"].includes(char) || pair === "\\n" || char === "\n") {
          cutIndex = i;
          break;
        }
      }
      return str.slice(0, cutIndex);
    }

    if (direction === "end") {
      let startIndex = Math.max(0, str.length - limit);

      for (let i = str.length - 1; i >= startIndex; i--) {
        const pair = str.slice(i - 1, i + 1);
        const char = str[i];

        if (["/", "\\"].includes(char) || pair === "\\n" || char === "\n") {
          startIndex = i + 1;
          break;
        }
      }

      return str.slice(startIndex);
    }

    return str;
  }




  // Getting actual and correction file from api

  // useEffect(() => {
  //   const tex = async () => {
  //     const file = await downloadTexApi();
  //     try {
  //       setTexFile(file.data.tex);
  //       setActualValue(file.data.proof_tex);
  //       setFilename(file.data.file);
  //       props.setFileName(file.data.file);
  //     } catch (error) {
  //       setTexFile("No File Found");
  //       setLoading(false);
  //       // return navigate("home");
  //     } finally {
  //       setLoading(false);
  //     }

  //     setTimeout(() => {
  //       enableMarkers();
  //       ace.current.editor.session.getUndoManager().reset();
  //     }, 2000);
  //   };
  //   tex();

  //   ace.current.editor.setOption("enableMultiselect", false);
  //   // window.ace = ace.current;
  // }, []);

  useEffect(() => {
    if (!props.isChecked) {
      onChange(texFile);

      props.uploadtex(texFile);
    }

  }, [actualValue, texFile]);

  useEffect(() => {
    if (props.isChecked && check) {
      let tempFiles = texFile;
      if (tempFiles !== "No File Found") {
        let oldValue = texFile;

        props.editTool[props.currentClient].forEach((i) => {
          tempFiles = client[i].action(texFile, filename, toast);

          onEditToolChange(tempFiles, client[i].name, i, texFile);
          oldValue = tempFiles;
          // EditToolCheck(oldValue, texFile, i)
        });
        setCheck(false)
      }
    }
  }, [texFile])

  useEffect(() => {
    if (props.isChecked) {
      setTexFile(toolActualValue)
      let tempFiles = toolActualValue;
      let oldValue = toolActualValue;
      if (tempFiles !== "No File Found") {
        props.editTool[props.currentClient].forEach((i) => {
          tempFiles = client[i].action(toolActualValue, filename, toast);

          onEditToolChange(tempFiles, client[i].name, i, toolActualValue);
          oldValue = tempFiles;
        });
      }
      // props.uploadtex(toolActualValue);
    }
  }, [toolActualValue])




  // useEffect(() => {
  //   props.uploadtex(texFile);
  // }, [changes, props, texFile]);

  useEffect(() => {
    if (!props.updateCorrections || props.isChecked) {
      return;
    }

    const data = props.updateCorrections.payload;
    const decision = props.updateCorrections.type;

    if (decision === "accept") {
      if (data.mode === "deleted") {
        let newAct = "";
        for (let i = 0; i < diffList.length; i++) {
          const curDiff = diffList[i];
          if (curDiff[0] === 0) newAct += curDiff[1];
          else if (curDiff[0] === -1 && i !== data.index) newAct += curDiff[1];
        }
        setActualValue(newAct);
      } else if (data.mode === "added") {
        let newAct = "";
        for (let i = 0; i < diffList.length; i++) {
          const curDiff = diffList[i];
          if (curDiff[0] === 0 || curDiff[0] === -1) newAct += curDiff[1];
          else if (curDiff[0] === 1 && i === data.index) newAct += curDiff[1];
        }
        setActualValue(newAct);
      }
    } else if (decision === "reject") {
      if (data.mode === "deleted") {
        let newAct = "";
        for (let i = 0; i < diffList.length; i++) {
          const curDiff = diffList[i];
          if (curDiff[0] === 0 || curDiff[0] === 1) newAct += curDiff[1];
          else if (curDiff[0] === -1 && i === data.index) newAct += curDiff[1];
        }
        setTexFile(newAct);
      } else if (data.mode === "added") {
        let newAct = "";
        for (let i = 0; i < diffList.length; i++) {
          const curDiff = diffList[i];
          if (curDiff[0] === 0) newAct += curDiff[1];
          else if (curDiff[0] === 1 && i !== data.index) newAct += curDiff[1];
        }
        setTexFile(newAct);
        props.exampleAction([]);
      }
    }
  }, [diffList, props.updateCorrections]);

  useEffect(() => {
    if (!props.updateToolCorrections || !props.isChecked) {
      props.editToolAction({})
      return;
    }

    var item = props.updateToolCorrections.payload
    var decision = props.updateToolCorrections.type

    if (decision === "ToolAccept") {
      let newAct = ""
      let finalAct = ""
      let lastAct = ""
      toolDiffList[item.key].forEach((curDiff, i) => {
        const prev = toolDiffList[item.key][i - 1];

        const matchedData = item.data.find(d => d.index === i);
        const matchData = item.data.find(d => d.index + 1 === i);

        if (curDiff[0] === 0) {
          newAct += curDiff[1];
        } else if (curDiff[0] === -1 && !matchedData) {
          newAct += curDiff[1];
        } else if (curDiff[0] === 1) {

          if (
            (prev && prev[0] === 0 && matchedData) ||
            (prev && prev[0] === -1 && matchData)
          ) {
            newAct += curDiff[1];
          }
        }
      });

      let r = dmp.diff_main(String(texFile), String(newAct));

      r.forEach((curDiff, i) => {
        if (curDiff[0] === 0) {
          finalAct += curDiff[1];
        } else if (curDiff[0] === 1) {
          finalAct += curDiff[1];
        }
      });
      let diff = dmp.diff_main(String(newAct), String(finalAct));
      diff.forEach((curDiff, i) => {
        lastAct += curDiff[1];
      });

      setToolActualValue(finalAct)


    } else if (decision === "ToolReject") {

      props.editToolRejected(item.data)

    }
  }, [props.updateToolCorrections]);
  // sending ref from child to parent component

  useEffect(() => {

    if (!props?.editTool?.[props?.currentClient]?.length) return;
    let tempFiles = texFile;
    let oldValue = texFile
    if (tempFiles !== "No File Found") {
      props.editTool[props.currentClient].forEach((i) => {
        // console.log(props.currentClient[i]);
        tempFiles = client[i]?.action(texFile, filename, toast);
        onEditToolChange(tempFiles, client[i].name, i, texFile);
        oldValue = tempFiles;
      });
      // let r = dmp.diff_main(String(texFile), String(tempFiles));
      // dmp.diff_cleanupSemantic(r);
      // setToolDiffList(r)
    }
  }, [props.editRejected])



  // sending ref from child to parent component
  useImperativeHandle(ref, () => ({
    editor: ace?.current?.editor,
  }));

  // useeffect to scrolltoline in PE/CE Tools;

  useEffect(() => {
    if (props.selection) {
      let start = props.selection.start;
      ace.current.editor.session.selection.setSelectionRange(props.selection);
      ace.current.editor.scrollToLine(start.row);
    }
  }, [props.selection]);

  useEffect(() => {
    switch (props?.currentClient) {
      case "epl":
        setClient(epl)
        break;
      case "edp":
        setClient(edp)
        break;
      default:
        setClient(epl)
        break;
    }
  }, [props.currentClient])

  // useeffect for showing deleted text on hover

  useEffect(() => {
    let editor = ace.current;
    if (changes) {
      editor?.editor?.on("mousemove", (e) => showDeletedOnHover(e, changes, setPopUp, popUp, hidePopover));
    }
    return () => {
      if (editor) {
        editor?.editor?.off("mousemove", showDeletedOnHover);
      }
    };
  }, [changes, popUp]);

  // useeffect for showing the markers on selection
  useEffect(() => {
    let editor = ace.current;
    if (markers) {
      editor?.editor?.on("mouseup", (e) => processSelection(e, hidePopover, markers, bibitems, setPopUp, ImagePopup, CitationPopup, toast, MathPopup, equations, props, tables));
    }
    return () => {
      if (editor) {
        editor?.editor?.off("mouseup", processSelection);
      }
    };
  }, [markers]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.ctrlKey && event.key === "T") {
        event.preventDefault();
      }
    });
  }, []);

  //Spell check
  useEffect(() => {
    if (ace.current && ace.current.editor) {
      enableSpellCheck(ace.current.editor);
    }
  }, []);

  useEffect(() => {
    //  Ace injects the prompt 
    const observer = new MutationObserver(() => {
      const promptBox = document.querySelector(".ace_prompt_container");
      if (promptBox) {
        //  custom styling
        promptBox.style.background = "#f8f9fa";
        promptBox.style.border = "1px solid #999";
        promptBox.style.borderRadius = "8px";
        promptBox.style.boxShadow = "0 4px 12px rgba(0,0,0,0.2)";
        promptBox.style.padding = "10px";
        promptBox.style.fontFamily = "monospace";

        const input = promptBox.querySelector(".ace_text_input");
        if (input) {
          input.style.padding = "6px 8px";
          input.style.borderRadius = "4px";
          input.style.border = "1px solid #ccc";
          input.style.outline = "none";
          input.style.fontSize = "14px";
          input.style.width = "100%";
          input.style.height = "20px";
        }

        //recents clear
        const history = promptBox.querySelector(".ace_autocomplete");
        if (history) history.remove();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  // useeffect for shortcut key bindings

  // const extraProps = { projectMode: props.projectMode, compileTex: props.compileTex, compileTrack: props.compileTrack };
  //MARK:Shortcut-Keys 
  // aceShortcuts(ace, { ...props, extraProps });


  useEffect(() => {
    // console.log(props); 
    aceShortcuts(ace, props);
  }, []);


  // useeffect for searching the text in pdf on selection in editor
  useEffect(() => {
    let curSearch = props.latexsearch;
    if (curSearch && curSearch.length > 3 && curSearch !== lastSearch) {
      setSearchFromPdf(curSearch);
      setLastSearch(curSearch);
    }
  }, [props.latexsearch, lastSearch]);

  // function to search the text on editor on selection in pdf
  const setSearchFromPdf = (search) => {
    ace.current.editor.find(search);
  };


  // function to hidepopups
  //MARK:Hidepopover
  const hidePopover = () => {
    setPopUp({ popup: { show: false } });
  };

  // function to enable markers in ace editor
  const enableMarkers = () => {
    if (texFile) {
      setBibitems(getAllBibitems(texFile));
      setEquations(getAllEquations(texFile));
      setTables(getAllTables(texFile));
    }
    // getAllBibitems(texFile);
    if (ace?.current?.editor) {
      var markers = getCitationMarkers(styles, ace);
      var inlineEqnMarkers = getInlineEqnMarkers(ace, styles);
      var eqnMarkers = getEqnMarkers(ace, styles);
      var allMarkers = [].concat(
        inlineEqnMarkers,
        eqnMarkers,
        markers
      );
    }
    setMarkers(allMarkers);
    querySelector(ace, props);
  };


  // const Diffcalc = useMemo(() => {
  //   // Memoized diff calculation
  //   return (actualValue, newValue) => {
  //     const diff = dmp.diff_main(actualValue, newValue);
  //     // dmp.diff_cleanupSemantic(diff); // Optional: improve diff quality
  //     return diff;
  //   };
  // }, []);

  // const debouncedOnChange = useCallback(
  //   debounce((actualValue, newValue) => {
  //     const diff = Diffcalc(actualValue, newValue);
  //     console.log(diff); // Handle the diff
  //   }, 100), // Adjust the delay as needed
  //   []
  // // );

  // const processDiffAndMarkers = useCallback(
  //   debounce((actualValue, newValue) => {
  //     const diff = Diffcalc(actualValue, newValue);
  //     let allMarkers = [];
  //     let st = 0;
  //     setDiffList(diff);

  //     // Generate markers from diff
  //     for (let j = 0; j < diff.length; j++) {
  //       const i = diff[j];
  //       console.log(i);

  //       if (i[0] === 1) {
  //         let value = i[1];
  //         let start = ace.current.editor.session.doc.indexToPosition(st);
  //         let end = ace.current.editor.session.doc.indexToPosition(
  //           st + value.length
  //         );
  //         allMarkers.push({
  //           startRow: start.row,
  //           startCol: start.column,
  //           endRow: end.row,
  //           endCol: end.column,
  //           startIndex: st,
  //           endIndex: end,
  //           className: styles.added_marker,
  //           type: "text",
  //           text: value,
  //           mode: "added",
  //           index: j
  //         });
  //         st += value.length;
  //       } else if (i[0] === -1) {
  //         let value = i[1];
  //         let start = ace.current.editor.session.doc.indexToPosition(st);
  //         let end = ace.current.editor.session.doc.indexToPosition(st);
  //         allMarkers.push({
  //           // time: time,
  //           startRow: start.row,
  //           startCol: start.column,
  //           endRow: end.row,
  //           endColumn: end.column,
  //           startIndex: st,
  //           endIndex: end,
  //           className: styles.deleted_marker,
  //           type: "background",
  //           text: value,
  //           mode: "deleted",
  //           index: j
  //         });
  //       } else {
  //         st = st + i[1].length;
  //       }

  //     }

  //     // Update markers and call actions
  //     setChanges(allMarkers);
  //     props.exampleAction(allMarkers);
  //     enableMarkers();
  //     return true
  //   }, 700), // Adjust debounce delay for better performance
  //   []
  // );

  // const onChange = (newValue) => {
  //   setTexFile(newValue);
  //   editorValueRef.current = newValue;

  //   // Debounced diff calculation
  //   processDiffAndMarkers(actualValue, newValue);
  // };

  // console.log("time taken :", performancetime);

  //MARK:Compare changes
  // function to compare changes in the tex file and actual file.
  const onChange = (newValue) => {
    if (toggleChange && newValue) {
      let start = performance.now()
      var r = dmp.diff_main(actualValue, newValue);
      // var r = debouncedOnChange(actualValue, newValue)
      // dmp.diff_cleanupSemantic(r)
      // var p = dmp.patch_make(r) 
      // console.log(r);
      // console.log(p);
      let allMarkers = [];
      var st = 0;
      setDiffList(r);
      for (var j = 0; j < r.length; j++) {
        var i = r[j]
        if (i[0] === 1) {
          let value = i[1];
          let start = ace.current.editor.session.doc.indexToPosition(st);
          let end = ace.current.editor.session.doc.indexToPosition(
            st + value.length
          );
          allMarkers.push({
            // time: time,
            startRow: start.row,
            startCol: start.column,
            endRow: end.row,
            endCol: end.column,
            startIndex: st,
            endIndex: end,
            className: styles.added_marker,
            type: "text",
            text: value,
            mode: "added",
            index: j
          });
          st = st + value.length;
        } else if (i[0] === -1) {
          let value = i[1];
          let start = ace.current.editor.session.doc.indexToPosition(st);
          let end = ace.current.editor.session.doc.indexToPosition(st);
          allMarkers.push({
            // time: time,
            startRow: start.row,
            startCol: start.column,
            endRow: end.row,
            endColumn: end.column,
            startIndex: st,
            endIndex: end,
            className: styles.deleted_marker,
            type: "background",
            text: value,
            mode: "deleted",
            index: j
          });
        } else {
          st = st + i[1].length;
        }
      }
      let end = performance.now();
      setChanges(allMarkers);
      props.exampleAction(allMarkers);
      setPerformanceTime(end - start)

    }
    setTexFile(newValue);
    enableMarkers();
    setCheck(true);
    return true;
    // } catch (e) {
    //   alert("Problem with file, Please check")
    // }
  };

  const AceDocumentRef = useRef(null);

  useEffect(() => {
    if (!ace.current?.editor) return;

    // Give Ace a tick to load its modules
    setTimeout(() => {
      let DocConstructor = null;

      if (window.ace && window.ace.require) {
        DocConstructor = window.ace.require("ace/document").Document;
      } else if (window.acequire) {
        DocConstructor = window.acequire("ace/document").Document;
      }

      if (!DocConstructor) {
        console.error("Ace Document could not be loaded — check your ace setup.");
        return;
      }

      AceDocumentRef.current = DocConstructor;
    }, 0);
  }, [ace]);



  const onEditToolChange = (newValue, name = "changes", key, oldValue) => {
    // try {
    if (toggleChange && newValue) {
      const AceDocument = AceDocumentRef.current;
      const oldDoc = new AceDocument(newValue);
      // const session = new aces.EditSession(oldValue);

      // Get the underlying document
      // const oldDoc = session.getDocument();
      // let start = performance.now()
      let r = dmp.diff_main(String(oldValue), String(newValue));
      dmp.diff_cleanupSemantic(r);
      // var r = debouncedOnChange(actualValue, newValue)
      // dmp.diff_cleanupSemantic(r)
      // var p = dmp.patch_make(r) 

      let allMarkers = [];
      let st = 0;

      setToolDiffList(prev => ({
        ...prev,
        [key]: r
      }));


      for (let j = 0; j < r.length - 1; j++) {
        var i = r[j];

        let oldText;
        let newText;

        if (i[0] === 1) {
          let next = r[j + 1];
          let prev = r[j - 1];
          let value = i[1];
          let start = oldDoc.indexToPosition(st);
          let end = oldDoc.indexToPosition(st + value.length);
          if (value === "") continue;

          // Only add marker if prev exists and is 0
          if (prev?.[0] === 0) {
            oldText = (prev ? smartTrim(prev[1], "end") : "") + (next ? smartTrim(next[1]) : "");
            newText = (prev ? smartTrim(prev[1], "end") : "") + value + (next ? smartTrim(next[1]) : "");

            allMarkers.push({
              name,
              key,
              texts: { oldText, newText },
              data: {
                startRow: start.row,
                startCol: start.column,
                endRow: end.row,
                endCol: end.column,
                startIndex: st,
                endIndex: st + value.length - 1,
                className: styles.added_marker,
                type: "text",
                text: value,
                mode: "added",
                index: j
              }
            });
          }

          st += value.length;

        } else if (i[0] === -1) {
          let next = r[j + 1];
          let next1 = r[j + 2];
          let prev = r[j - 1];
          let value = i[1];
          let start = oldDoc.indexToPosition(st);
          let end = oldDoc.indexToPosition(st);

          if (value === "") continue;

          if (next?.[0] === 1) {
            oldText = (prev ? smartTrim(prev[1], "end") : "") + value + (next1 ? smartTrim(next1[1]) : "");
            newText = (prev ? smartTrim(prev[1], "end") : "") + (next?.[1] || "") + (next1 ? smartTrim(next1[1]) : "");
          } else if (next?.[0] === 0 || !next) {
            oldText = value + (next ? smartTrim(next[1]) : "");
            newText = next ? smartTrim(next[1]) : "";
          }

          allMarkers.push({
            name,
            key,
            texts: { oldText, newText },
            data: {
              startRow: start.row,
              startCol: start.column,
              endRow: end.row,
              endColumn: end.column,
              startIndex: st,
              endIndex: st + value.length - 1,
              className: styles.deleted_marker,
              type: "background",
              text: value,
              mode: "deleted",
              index: j
            }
          });

        } else {
          // Keep original flow for 0
          st += i[1].length;
        }
      }


      let end = performance.now();
      // setChanges(allMarkers);



      props.editToolAction({ key, data: allMarkers });
      // setPerformanceTime(end - start)
    }

    // setTexFile(newValue);
    // enableMarkers();
    return true;
    // } catch (e) {
    //   alert("Problem with file, Please check")
    // }
  };
  // console.log("updateCorrections changed:", props.updateCorrections);

  // // function to insert Math equations in texfile
  const insertMath = (text) => {
    ace.current.editor.session.insert(
      ace.current.editor.getCursorPosition(),
      text
    );
  };
  // const triggerMath = () => insertMath();//for button

  // function to save texfile
  const saveTex = async () => {
    props.toast({
      title: "Saving Tex.",
      description: "File is being saved, Please wait.",
      status: "info",
      icon: (
        <Spinner
          thickness="4px"
          emptyColor="gray.200"
          color="blue.500"
          size="sm"
        />
      ),
    });
    // var result = await saveTexApi(texFile, changes);
    var result = await update_project_file_Api(projectid, fileId, filename, texFile)
    if (result.data) {
      props.toast.closeAll();

      props.toast({
        title: "Tex saved.",
        description: "Save successfull.",
        status: "success",
        duration: 1000,
      });
    }
  };



  const AutoCorrect = () => {
    toast({ title: "Feature yet to be Implemented" });
  };

  // useeffect to apply copy editing styles.

  useEffect(() => {
    if (!props.editing) {
      // props.editToolAction([]);

      // toast({ title: "Error in applying styles" });
      return;
    }
    var currentstyle;
    var tempFile = texFile;
    if (tempFile !== "No File Found") {
      props.editing.forEach((i) => {
        currentstyle = client[i]?.name;
        tempFile = client[i]?.action(tempFile, filename, toast);
      });
      toast({
        title: "Applying Styles",
        description: currentstyle,
        duration: 1500,
      });
      setTexFile(tempFile);
    } else {
      toast({
        title: "Error",
        description: "Please Load file to continue.",
        duration: 1500,
      });
    }
  }, [props.editing]);


  useEffect(() => {
    if (!props.isChecked && !props.editTool?.[props?.currentClient]?.length) {
      props.editToolAction({});

      // toast({ title: "Error in applying styles" });
      return;
    }
    navigate("#suggestions")
    var currentstyle;
    var tempFile = texFile;
    let oldValue = texFile
    if (tempFile !== "No File Found") {
      props.editTool[props.currentClient].forEach((i) => {
        tempFile = client[i].action(texFile, filename, toast);

        onEditToolChange(tempFile, client[i].name, i, texFile);
        oldValue = tempFile;

      });


      toast({
        title: "Applying Styles",
        description: currentstyle,
        duration: 1500,
      });
    } else {
      toast({
        title: "Error",
        description: "Please Load file to continue.",
        duration: 1500,
      });
    }
  }, [props.isChecked, props.editTool]);
  //MARK:Get file mode 
  // useEffect(() => {
  //   if (editorRef.current) {
  //     const editor = editorRef.current.editor;
  //     const mode =
  //       props.fileType === "txt" ? "ace/mode/text" : "ace/mode/latex";
  //     editor.session.setMode(mode);
  //   }
  // }, [props.fileType]);


  useEffect(() => {
    const editor = ace.current?.editor;
    if (!editor) return;
    if (!editor.getReadOnly()) return; // attach only if read-only

    const handleKeyDown = (e) => {
      if (e.key.length === 1) {
        e.preventDefault();
        suggestToggle();
      }
    };

    const container = editor.container;
    container.addEventListener("keydown", handleKeyDown);

    return () => {
      container.removeEventListener("keydown", handleKeyDown);
    };
  }, [ace.current?.editor?.getReadOnly()]);






  //MARK:Rendering part
  return (
    <>
      <div style={styles.ace_editor}>
        <Loading loading={loading} />
        <span>
          <HStack
            backgroundColor="var(--editor-bg)"
            justifyContent="space-between"
            maxH="48px"
            minH="48px"
          >
            <ButtonGroup spacing="1" alignItems={"center"}>

              {props.leftController ? (
                <Tooltip label="Close panel">
                  <IconButton
                    onClick={() => {
                      props.toggleLeftPanel();
                    }}
                    size="lg"
                    colorScheme="var(--editor-bg)"
                    aria-label="Close Left Panel"
                    icon={<MenuClose />}
                    _hover={{ bg: "var(--editor-hover)" }}
                  />
                </Tooltip>
              ) : (
                <Tooltip label="Open panel">
                  <IconButton
                    onClick={() => {
                      props.toggleLeftPanel();
                    }}
                    size="md"
                    colorScheme="var(--editor-bg)"
                    aria-label="Open Left Panel"
                    icon={<MenuBar />}
                    _hover={{ bg: "var(--editor-hover)" }}
                  />
                </Tooltip>
              )}

              <Tooltip label="Search">
                <IconButton
                  onClick={() => ace.current.editor.execCommand("find")}
                  size="md"
                  colorScheme="var(--editor-bg)"
                  aria-label="Search inside document"
                  icon={<SearchIcon />}
                  _hover={{ bg: "var(--editor-hover)" }}
                />
              </Tooltip>
              <Tooltip label="Text to Bold">
                <IconButton
                  onClick={() => textToBold(ace)}
                  size="lg"
                  colorScheme="var(--editor-bg)"
                  aria-label="Text to Bold"
                  icon={<BoldIcon />}
                  _hover={{ bg: "var(--editor-hover)" }}
                />
              </Tooltip>
              <Tooltip label="Text to Italic">
                <IconButton
                  onClick={() => textToItalics(ace)}
                  fontSize="l"
                  size="lg"
                  colorScheme="var(--editor-bg)"
                  aria-label="Text to Italic"
                  icon={<ItalicIcon />}
                  _hover={{ bg: "var(--editor-hover)" }}
                />
              </Tooltip>

              <Box
                height="34px"
                width="1px"
                bgGradient="linear(to-b, transparent, white, transparent)"
                mx={2}
                alignSelf="center"
              />

              <Tooltip label="Replace">
                <IconButton
                  id="replace"
                  onClick={() => ace.current.editor.execCommand("replace")}
                  color="white"
                  size="lg"
                  colorScheme="var(--editor-bg)"
                  aria-label="Replace inside document"
                  icon={<ReplaceIcon />}
                  _hover={{ bg: "var(--editor-hover)" }}
                />
              </Tooltip>

              <InsertMath insertMath={insertMath} />


              <Tooltip label="SpellCheck">
                <IconButton
                  onClick={AutoCorrect}
                  size="lg"
                  colorScheme="var(--editor-bg)"
                  aria-label="Autocorrect"
                  icon={<Auto />}
                  _hover={{ bg: "var(--editor-hover)" }}
                />
              </Tooltip>

              <Box
                height="34px"
                width="1px"
                bgGradient="linear(to-b, transparent, white, transparent)"
                mx={2}
                alignSelf="center"
              />

              <Tooltip label="Show/Hide Changes">
                <Box display="flex" gap={2} alignItems="center">
                  <Switch
                    isChecked={toggleChange}
                    onChange={() => {
                      setToggleChange(!toggleChange);
                      onChange(texFile);
                    }}
                    size="md"
                    sx={{
                      // Track styles
                      ".chakra-switch__track": {
                        bg: "white",
                        border: "2px solid var(--editor-bg)",
                        _checked: {
                          bg: "white",
                        },
                      },
                      // Thumb styles
                      ".chakra-switch__thumb": {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        bg: toggleChange ? "var(--editor-bg)" : "#D2CFCE",
                        _after: {
                          content: 'url("/images/Redesignpics/tick.svg")',
                          fontSize: "18px",
                          color: "white",
                          opacity: toggleChange ? 1 : 0,
                          transition: "opacity 0.2s ease",
                        },
                      },
                    }}
                  />

                  <p style={{ color: "#fff", fontWeight: "500" }}>Corrections</p>
                </Box>
              </Tooltip>
            </ButtonGroup>

            <ButtonGroup display={"flex"} alignItems={"center"}>

              <Tooltip label="Save">
                <Box as="button" onClick={saveTex} background={"#FFF"} display={"flex"} alignItems={"center"} py={1} pr={3} mr={3} borderRadius={"8px"} marginRight={"auto"}>
                  <IconButton
                    size="lg"

                    colorScheme="var(--editor-bg)"
                    aria-label="Save Tex File"
                    icon={<svg width="18" color="var(--editor-bg)" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_598_355)">
                        <path d="M4.5 3H12L15 6V13.5C15 13.8978 14.842 14.2794 14.5607 14.5607C14.2794 14.842 13.8978 15 13.5 15H4.5C4.10218 15 3.72064 14.842 3.43934 14.5607C3.15804 14.2794 3 13.8978 3 13.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.5 10.5C7.5 10.8978 7.65804 11.2794 7.93934 11.5607C8.22064 11.842 8.60218 12 9 12C9.39782 12 9.77936 11.842 10.0607 11.5607C10.342 11.2794 10.5 10.8978 10.5 10.5C10.5 10.1022 10.342 9.72064 10.0607 9.43934C9.77936 9.15804 9.39782 9 9 9C8.60218 9 8.22064 9.15804 7.93934 9.43934C7.65804 9.72064 7.5 10.1022 7.5 10.5Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.5 3V6H6V3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_598_355">
                          <rect width="18" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>}
                    height={"fit-content"}
                    p={0}
                    m={[2, -2]}
                  // _hover={{ bg: "var(--editor-hover)" }}
                  />
                  <Text style={{ color: "var(--editor-bg)", fontWeight: "500" }}>Save</Text>
                </Box>
              </Tooltip>

              <Box>
                {props.pdfviewer ? (
                  <Tooltip label="Expand Editor">
                    <IconButton
                      onClick={() => {
                        props.togglePDF();
                      }}
                      size="md"
                      colorScheme="var(--editor-bg)"
                      aria-label="toogle-pdf"
                      // position="absolute"
                      right="0"
                      z-index="2"
                      bg="var(--editor-bg)"
                      icon={<Resize1 />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    ></IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip label="Minimise editor">
                    <IconButton
                      onClick={() => {
                        props.togglePDF();
                      }}
                      size="md"
                      // position="absolute"
                      right="0"
                      colorScheme="var(--editor-bg)"
                      aria-label="toogle-pdf"
                      icon={<Resize2 />}
                      _hover={{ bg: "var(--editor-hover)" }}
                    ></IconButton>
                  </Tooltip>
                )}
              </Box>
            </ButtonGroup>
          </HStack>

          <PopOver state={popUp} onClick={() => hidePopover()} />
          <Modal isOpen={alertOpen} onClose={onalertClose} isCentered>
            <ModalOverlay>
              <ModalContent>
                <ModalHeader>
                  Alert
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody overflow="auto" padding="20px">
                  <Box>
                    <p>
                      Corrections on the file is too high please disable the Real Time Diff functionality to have a smooth editing experience.
                    </p>
                  </Box>
                  <Box mt="15px">
                    <Button onClick={() => { setToggleChange(false); onalertClose() }}> Turn off Real Time Diff </Button>
                  </Box>
                </ModalBody>
              </ModalContent>
            </ModalOverlay>
          </Modal>
          <ReusableModal
            isOpen={suggestOpen}
            onClose={suggestClose}
            title="Alert"
            footerButtons={[
              { label: "Close", closeOnClick: true }
            ]}
          >
            <p style={{ fontSize: "18px" }}>Please clear all suggestions to continue editing.</p>
          </ReusableModal>
          {/*MARK:Ace Setup*/}
          <AceEditor
            // onMouseMove={showDeletedOnHover}
            ref={ace}
            markers={toggleChange ? markers.concat(changes) : markers}
            mode="latex"
            theme={customtheme == "dark" ? "dracula" : customtheme == "black" ? "terminal" : "xcode"}
            name="ace_editor"
            wrapEnabled={true}
            editorProps={{ $blockScrolling: true }}
            options={{ enableMultiselect: false, enableLiveAutocompletion: false, enableLiveAutocompletion: false }}
            fontSize={18}
            readOnly={isEditable}
            onChange={onChange}
            value={texFile}
            enableSnippets={false}
            enableBasicAutocompletion={false}
            enableLiveAutocompletion={false}
            width="100%"
            height="calc(90vh - 48px)"
          />
        </span>
      </div>
    </>
  );
});

//Dispatch state to props redux
const mapStateToProps = (state, ownProps) => ({
  corrections: state.EditTool.EditCorrections,
  data: state.correction.corrections,
  states: state,
  latexsearch: state.latexsearch.latexSearch,
  selection: state.toolsearch.toolSearch,
  query: state.queries.queries,
  editing: state.eplStyles.function,
  editTool: state.toolStyles.function,
  editRejected: state.editToolRejected.editReject,
  isChecked: state.toolStyles.isChecked,

  compileTex: state.compileTex.compile,
  compileTrack: state.trackCompile.trackcompile,
  TexcompileTrig: state.compileTrig.compileTrigger,
  TrackcompileTrig: state.compileTrackTrig.compileTrackTrigger,
  projectMode: state.projectMode.projectMode,

  updateCorrections: state.updateCorrections.corrections,
  updateToolCorrections: state.updateToolCorrections.corrections,
  currentClient: state.clientSelect.clientselect
});

//Dispatch action redux
const mapDispatchToProps = (dispatch) => {
  return {
    exampleAction: (data) => dispatch({ type: "EDIT", payload: data }),
    editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
    editToolRejected: (data) => dispatch({ type: "AddReject", payload: data }),
    querydata: (data) => dispatch({ type: "QueryEdit", payload: data }),
    uploadtex: (data) => dispatch({ type: "UploadTex", payload: data }),
    pdfsearch: (data) => dispatch({ type: "pdfSearch", payload: data }),
    compileTrigger: () => dispatch({ type: "TRIGGER_COMPILE" }),
    compileTrackTrigger: () => dispatch({ type: "TRIGGER_TRACK_COMPILE" })
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AceFunctional);

